module.exports = __webpack_public_path__ + "94cb74cbf4fe9f846efeb75397604f57.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/paypalwhite.svg
// module id = 1508
// module chunks = 1 5 7 8 15 80